export default __webpack_public_path__ + "static/media/popup-icon-alert.9c1b2c27.svg";